<!-- LanguageChanger.vue -->
<script setup lang="ts">
import i18n from "@/i18n";
import { Composer } from "vue-i18n";
import { mdiWeb } from '@mdi/js';

const currentLocale = (i18n.global as unknown as Composer).locale;

</script>

<template>
  <div class="languages" title="Select Your Language">
    <label for="selLanguage">
      <svg
        class="languages-icon"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path fill-rule="evenodd" fill="#fff" :d="mdiWeb" />
      </svg>
    </label>
    <select id="selLanguage" v-model="currentLocale" name="language">
      <option
        v-for="locale in i18n.global.availableLocales"
        :key="`locale-${locale}`"
        :value="locale"
      >
        {{ locale }}
      </option>
    </select>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/sass/mixin.scss";

.languages {
  display: block;
  position: fixed;
  right: 1rem;
  top: .5rem;
  box-sizing: border-box;
  padding: .25rem;
  opacity: 1;
  z-index: 10000;
  &-icon {
    vertical-align: middle;
    margin: .125rem;
  }
}

select {
  outline: none;
}

@include mq(sp) {
  .languages {
    right: 2px;
  }
}
</style>
